export default "__VITE_ASSET__bTOh5y2V__"